var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleIcon = function SvgScheduleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    y: 3,
    fill: "#4AA2C4",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M3 0h3v5H3zM12 0h3v5h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M3 7h12v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D2C89",
    d: "M3 12h12v3H3z"
  }))));
};
export default SvgScheduleIcon;